import { hasRole, roles, routePaths } from "../constants/roles";

export const getToken = () => localStorage.getItem("Bearer");

export const setToken = (token) => localStorage.setItem("Bearer", token);

export const removeToken = () => localStorage.removeItem("Bearer");

// Refresh token (introduit avec le refacto back JWT — paire access/refresh).
export const getRefreshToken = () => localStorage.getItem("RefreshToken");

export const setRefreshToken = (token) => localStorage.setItem("RefreshToken", token);

export const removeRefreshToken = () => localStorage.removeItem("RefreshToken");

// Expiration de l'access token (Instant ISO renvoyé par le back) — utilisé
// par l'intercepteur 401 (Phase 3) pour décider d'un refresh préventif.
export const getAccessExpiry = () => localStorage.getItem("AccessExpiry");

export const setAccessExpiry = (expiry) => localStorage.setItem("AccessExpiry", expiry);

export const removeAccessExpiry = () => localStorage.removeItem("AccessExpiry");

export const removeStorageItem = (key) => {
  if (localStorage.getItem(key)) {
    return localStorage.removeItem(key);
  }
  return;
};

export const getUserData = () => {
  if (
    localStorage.getItem("userdata") === null ||
    localStorage.getItem("userdata") === undefined
  ) {
    return null;
  } else {
    return JSON.parse(localStorage.getItem("userdata"));
  }
};

/**
 * Persiste {@code userdata} en respectant le shape rétro-compatible :
 * on duplique l'utilisateur sous {@code .user} pour les appelants qui lisent
 * encore {@code userdata.user.id} (legacy), tout en exposant aussi les
 * champs à plat (nouveau shape).
 */
export const setUserData = (user) => {
  if (!user) return;
  const userdata = { ...user, user };
  localStorage.setItem("userdata", JSON.stringify(userdata));
};

/**
 * Renvoie l'utilisateur connecté au shape {@code UserResponse} (celui qui
 * porte le discriminant {@code role}), ou {@code null}. Lit indifféremment
 * {@code userdata} à plat (nouveau shape) ou {@code userdata.user} (legacy),
 * ce qui évite de répéter ce repli à chaque appelant.
 */
export const getLoggedInUser = () => {
  const userdata = getUserData();
  if (!userdata) return null;
  return userdata.role ? userdata : userdata.user ?? null;
};

/**
 * Renvoie l'id de l'utilisateur connecté (ou {@code null}). Lit
 * indifféremment {@code userdata.user.id} (legacy) ou {@code userdata.id}
 * (nouveau shape).
 */
export const getLoggedInUserId = () => {
  const ud = getUserData();
  if (!ud) return null;
  return ud?.user?.id ?? ud?.id ?? null;
};

/**
 * Page d'atterrissage par défaut selon les autorités effectives. Le profil
 * médecin prime : quiconque porte {@code ROLE_DOCTOR} (en principal ou en
 * rôle additionnel) arrive directement sur sa liste d'attente, les autres
 * sur la liste des patients.
 */
export const getDefaultLandingPath = () =>
  hasRole(getLoggedInUser(), roles.ROLE_DOCTOR)
    ? routePaths.QUEUE_DOCTOR
    : routePaths.PATIENTS;

export const setStoragePatient = (patient) =>
  localStorage.setItem("patient", JSON.stringify(patient));

export const setStorageInsurer = (insurer) =>
  localStorage.setItem("insurer", JSON.stringify(insurer));

export const getStoragePatient = () => {
  if (
    localStorage.getItem("patient") === null ||
    localStorage.getItem("patient") === undefined
  ) {
    return null;
  } else {
    return JSON.parse(localStorage.getItem("patient"));
  }
};

export const getStorageInsurer = () => {
  if (
    localStorage.getItem("insurer") === null ||
    localStorage.getItem("insurer") === undefined
  ) {
    return null;
  } else {
    return JSON.parse(localStorage.getItem("insurer"));
  }
};
